import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';
import { format } from 'date-fns';
import { ar } from 'date-fns/locale';

const chartConfig: ChartConfig = {
  delivered:  { label: 'تم التوصيل',  color: 'hsl(142, 72%, 42%)' },
  in_transit: { label: 'قيد النقل',   color: 'hsl(217, 91%, 60%)' },
  assigned:   { label: 'مُعيَّن',      color: 'hsl(262, 80%, 60%)' },
  picked_up:  { label: 'تم الاستلام', color: 'hsl(190, 70%, 50%)' },
  pending:    { label: 'قيد الانتظار',color: 'hsl(38, 92%, 50%)'  },
  failed:     { label: 'فشل',         color: 'hsl(0, 84%, 60%)'   },
  cancelled:  { label: 'ملغى',        color: 'hsl(0, 0%, 60%)'    },
};

interface Props {
  data: Record<string, any>[];
  days?: number;
}

function formatDate(d: string) {
  try {
    return format(new Date(d), 'd MMM', { locale: ar });
  } catch {
    return d;
  }
}

export function ShipmentTrendChart({ data, days = 30 }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  // Determine which statuses have data
  const statuses = Object.keys(chartConfig).filter((s) =>
    data.some((d) => (d[s] ?? 0) > 0),
  );

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <AreaChart data={data} margin={{ top: 4, right: 12, left: -16, bottom: 0 }}>
        <defs>
          {statuses.map((s) => (
            <linearGradient key={s} id={`grad-${s}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={`var(--color-${s})`} stopOpacity={0.3} />
              <stop offset="95%" stopColor={`var(--color-${s})`} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/40" />
        <XAxis dataKey="date" tickFormatter={formatDate} tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          formatter={(v: any, name: string) => [v, chartConfig[name]?.label ?? name]}
          labelFormatter={formatDate}
        />
        <Legend
          formatter={(name) => chartConfig[name]?.label ?? name}
          wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
        />
        {statuses.map((s) => (
          <Area
            key={s}
            type="monotone"
            dataKey={s}
            stackId="1"
            stroke={`var(--color-${s})`}
            fill={`url(#grad-${s})`}
            strokeWidth={2}
          />
        ))}
      </AreaChart>
    </ChartContainer>
  );
}
